import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import {
  Button,
  message,
  Input,
  Form,
  Select,
  Checkbox,
  Row,
  Col,
  DatePicker,
} from "antd/lib";
import { useDispatch, useSelector } from "react-redux";
import { ONBDetils } from "../../Redux/actions/OnboardAction";
import moment from "moment";
import { UatNav } from "../Navbar/UatNav";
import { EmpNav } from "../Navbar/EmpNav";
import axiosInPosp from "../../Redux/axios/AxiosInPosp";
import "./onboard.css";
function ONBProfileDetails() {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  const RemPass = useSelector((state) => state?.pass);
  const OTPData = useSelector((state) => state?.posp?.onboardOtp);
  const OnbNum = useSelector((state) => state?.posp?.onbNum);
  const [StateData, setStateData] = useState([]);
  const [LogDetail, setLogDetail] = useState(RemPass);
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [iserror, setiserror] = useState(false);
  const [loading, setloading] = useState(false);
  //   const [rememberPassword, setRememberPassword] = useState(false);
  const [BaseUrl, setBaseURL] = useState("");
  console.log(OTPData);
  const history = useHistory();
  useEffect(() => {
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    setBaseURL(BASEURL);
    fetchStates();
  }, [BaseUrl]);

  const fetchStates = () => {
    axiosInPosp
      .get(`v1/posp/profile/edit`)
      .then((res) => {
        console.log(res);
        const SData = res?.data?.states;
        setStateData(SData);
        const ProfData = res?.data?.profile;
        console.log(ProfData);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const disabledDate = (current) => {
    const today = moment();
    const minDate = today.subtract(18, "years");

    return current.isAfter(minDate, "day");
  };
  const getDefaultPickerValue = () => {
    const today = moment();
    const minDate = today.subtract(18, "years");
    return minDate;
  };
  const handleSubmit = (values) => {
    console.log(values);
    const token = OnbNum?.accessToken;

    const headers = {
      Authorization: `Bearer ${token}`,
    };
    let post = {
      name: values?.firstName,
      lastname: values?.lastname,
      email: values?.email,
      DateofBirth: moment(values?.dateofbirth).format("YYYY-MM-DD"),
      address: values?.address,
      gender: values?.gender,
      city: values?.city,
      state: values?.state,
      pincode: values?.pincode,
      quote_request_from: values?.quote_request_from,
    };

    setloading(true);
    axios
      .patch(`${BaseUrl}v1/posp/profile`, post, { headers })
      .then((res) => {
        console.log(res);
        const Udata = res?.data;
        console.log(Udata);
        setloading(false);
        dispatch(ONBDetils(Udata));
        message.success(
          "Password sent to your Registered Email!. Login to Continue"
        );
        history.push("/");
        dispatch({ type: "LOG_STATE" });
      })
      .catch((err) => {
        console.log(err.response);
        message.error(err?.response?.data?.message);
        // if (err.response.data.message === "Unauthenticated.") {
        //   dispatch({ type: "RESET_UAT" });
        // }
        setloading(false);
        //message.error('Invalid credentials!')
      });
    // } else {
    //   setiserror(true)
    // }
  };

  return (
    <>
      <EmpNav />
      <div className="row justify-content-center h-100 align-items-center">
        {/* <div className="left-c-section col-xl-5 col-lg-6 col-md-6">
            <div><img src={Logo} style={{width: "185px"}}></img></div> 
            <h1>Become a Vibe Insurance Advisor & earn <br/><span>Upto 100$ / Month</span> </h1>
        </div> */}
        {/* {OTPData?.otpResp?.message === "Otp sent to your phone number" ? <VerifyOtp/> : */}

        <div className="right-section-on col-xl-7 col-lg-7 col-md-6 col-sm-12">
          <div className="login-container-details">
            <div className="d-block text-center my-2">
              <h4 className="mb-2" style={{ color: "#00000069" }}>
                Profile Details
              </h4>
            </div>
            <Form
              onFinish={handleSubmit}
              form={form}
              requiredMark={false}
              layout="vertical"
            >
              <Row gutter={24}>
                <Col span={12}>
                  <Form.Item
                    label="First Name"
                    name="firstName"
                    rules={[
                      {
                        required: true,
                        message: "please input Name",
                      },
                    ]}
                    //initialValue={OwnerInfo?.Owner ? OwnerInfo?.Owner : vehicleDetail?.owner_name}
                  >
                    <Input style={{ width: "100%" }} placeholder="Enter Name" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Last Name"
                    name="lastname"
                    rules={[
                      {
                        required: true,
                        message: "please input Name",
                      },
                    ]}
                    //initialValue={OwnerInfo?.Owner ? OwnerInfo?.Owner : vehicleDetail?.owner_name}
                  >
                    <Input style={{ width: "100%" }} placeholder="Enter Name" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Email",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      // prefix={<UserOutlined />}
                      onChange={(e) => {
                        setemail(e.target.value);
                      }}
                      placeholder="Enter Email"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Date of Birth"
                    name="dateofbirth"
                    rules={[
                      {
                        required: true,
                        message: "Please select DOB",
                      },
                    ]}
                    //initialValue={NomineeDetail?.Nage ? moment(NomineeDetail?.Nage) : null}
                  >
                    <DatePicker
                      style={{ width: "100%", padding: "12px" }}
                      disabledDate={disabledDate}
                      defaultPickerValue={getDefaultPickerValue()}
                      format="YYYY-MM-DD"
                      //onChange={onDateChange}
                      placeholder="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Gender"
                    name="gender"
                    rules={[
                      {
                        required: true,
                        message: "please input gender",
                      },
                    ]}
                    //initialValue={OwnerInfo?.Owner ? OwnerInfo?.Owner : vehicleDetail?.owner_name}
                  >
                    <Select
                      placeholder="Select Gender"
                      options={[
                        {
                          value: 1,
                          label: "Male",
                        },
                        {
                          value: 2,
                          label: "Female",
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Address"
                    name="address"
                    rules={[
                      {
                        required: true,
                        message: "please input Address",
                      },
                    ]}
                    //initialValue={OwnerInfo?.Owner ? OwnerInfo?.Owner : vehicleDetail?.owner_name}
                  >
                    <Input
                      style={{ width: "100%" }}
                      placeholder="Enter Address"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="City"
                    name="city"
                    rules={[
                      {
                        required: true,
                        message: "please input city",
                      },
                    ]}
                    //initialValue={OwnerInfo?.Owner ? OwnerInfo?.Owner : vehicleDetail?.owner_name}
                  >
                    <Input style={{ width: "100%" }} placeholder="Enter City" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="State"
                    name="state"
                    rules={[
                      {
                        required: true,
                        message: "please input state",
                      },
                    ]}
                    //initialValue={OwnerInfo?.Owner ? OwnerInfo?.Owner : vehicleDetail?.owner_name}
                  >
                    <Select
                      placeholder="Select State"
                      showSearch
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      options={StateData?.map((p, index) => ({
                        key: index,
                        value: p?.id,
                        label: p?.state_name,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Pincode"
                    name="pincode"
                    rules={[
                      {
                        pattern: /^[0-9]{6}$/,
                        message: "Invalid pincode",
                      },
                      { required: true, message: "Enter pincode" },
                    ]}
                  >
                    <Input maxLength={10} placeholder="123456"></Input>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Agent Type"
                    name="quote_request_from"
                    rules={[
                      {
                        required: true,
                        message: "please select Agent type",
                      },
                    ]}
                    // initialValue={QuickPost?.quote_request_from}
                  >
                    <Select placeholder="Select">
                      <Select.Option value="dealers_subdealers">
                        Dealers/Subdealers
                      </Select.Option>
                      <Select.Option value="posp_outlet">Agents</Select.Option>
                      <Select.Option value="insur_company_emp">
                        Insurance Comp Employees
                      </Select.Option>
                      <Select.Option value="retail_outlet">
                        Retail Shops(Telecom,Groceries,Xerox,Petti Etc...,)
                      </Select.Option>
                      <Select.Option value="small_finance">
                        Small Finance/NBFC/CHIT Companies
                      </Select.Option>
                      <Select.Option value="e_commerce">
                        E COMMERCE
                      </Select.Option>
                      <Select.Option value="auto_shops">
                        Auto Shops(Workshops,Tyre,Batteries,Accessories Etc...,)
                      </Select.Option>
                      <Select.Option value="students">
                        Student/Others
                      </Select.Option>
                      <Select.Option value="franchise_owners">
                        Franchise_Owners
                      </Select.Option>
                      <Select.Option value="chief_advisor">
                        Chief Advisor
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item className="mb-2">
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    width: "100%",
                    background: "#293890",
                    border: "#293890",
                    marginTop: "3%",
                    maxHeight: "42px",
                    minHeight: "42px",
                  }}
                  loading={loading}
                >
                  Register
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
        {/* } */}
      </div>
    </>
  );
}

export { ONBProfileDetails };
